// src/utils/playerDomain.ts
import EventBus from "@/uitls/EventBus";
import { uploadClienterrorlog } from "@/api/im/index"

const CACHE_KEY = 'usablePlayerDomain';
const PLAYER_HEALTH_PATH = '/player-health.json';
const PLAYER_HEALTH_TOKEN = 'live-player-health-v1';

let currentDomainList = [];

export function getCachedDomain(): string | null {
  return localStorage.getItem(CACHE_KEY);
}

export function cacheDomain(domain: string): void {
  localStorage.setItem(CACHE_KEY, domain);
}

function getPlayerHealthUrl(domain: string): string {
  return `${domain.replace(/\/$/, '')}${PLAYER_HEALTH_PATH}?t=${Date.now()}`;
}

export async function testDomain(domain: string, timeout: number = 5000): Promise<boolean> {
  return new Promise((resolve) => {
    const controller = new AbortController();
    const signal = controller.signal;
    let finished = false;

    const finish = (result: boolean) => {
      if (finished) return;
      finished = true;
      clearTimeout(timer);
      resolve(result);
    };

    const timer = setTimeout(() => {
      controller.abort();
      finish(false);
    }, timeout);

    fetch(getPlayerHealthUrl(domain), {
      method: 'GET',
      cache: 'no-store',
      signal
    })
      .then(async (res) => {
        if (!res.ok) {
          finish(false);
          return;
        }

        try {
          const data = await res.json();
          finish(data && data.token === PLAYER_HEALTH_TOKEN);
        } catch (error) {
          finish(false);
        }
      })
      .catch(() => {
        finish(false);
      });
  });
}

async function testDomainByResponseOk(domain: string, timeout: number = 5000): Promise<boolean> {
  return new Promise((resolve) => {
    const controller = new AbortController();
    const signal = controller.signal;
    let finished = false;

    const finish = (result: boolean) => {
      if (finished) return;
      finished = true;
      clearTimeout(timer);
      resolve(result);
    };

    const timer = setTimeout(() => {
      controller.abort();
      finish(false);
    }, timeout);

    // health 文件全部不可用时，回退到旧版域名检测逻辑。
    fetch(domain, {
      method: 'HEAD',
      signal
    })
      .then((res) => {
        finish(res.ok);
      })
      .catch(() => {
        finish(false);
      });
  });
}

export function initPlayerDomain(domainList: string[]): string {
  if (!Array.isArray(domainList) || domainList.length === 0) {
    console.log('播放器域名列表不能为空');
    return;
  }

  currentDomainList = domainList;
  
  let cachedDomain = getCachedDomain();
   // ===== 新增逻辑：缓存不在最新域名池，直接废弃 =====
  if (cachedDomain && !domainList.includes(cachedDomain)) {

    localStorage.removeItem(CACHE_KEY);
    cachedDomain = null;
  }

  if (!cachedDomain) {
    cachedDomain = domainList[0];
    cacheDomain(cachedDomain);
    console.log('[播放器域名] 没有缓存，先用第一个:', cachedDomain);
  } else {
    console.log('[播放器域名] 使用缓存域名:', cachedDomain);
  }

  (async () => {
    const isCachedDomainOk = await testDomain(cachedDomain!);
    if (isCachedDomainOk) {
      console.log('[播放器域名] 缓存域名检测正常:', cachedDomain);
      return;
    }else{
      //上报播放器域名错误日志
      reportErrorDomain(cachedDomain);
    }

    console.log('[播放器域名] 缓存域名失效，开始探测其他域名');

    switchPlayerDomain();

  })();

  return cachedDomain;
}

export async function switchPlayerDomain(): Promise<string | null> {
  console.log('[播放器域名] 开始探测其他域名');

  let currentDomain = getCachedDomain();
  for (const domain of currentDomainList) {
    if (domain === currentDomain) continue;

    const isOk = await testDomain(domain);
    if (isOk) {
      console.log('[播放器域名] 探测到新的可用域名:', domain);
      cacheDomain(domain);
      EventBus.emit("changePlayDomainNotication");
      return domain;
    } else {
      // 上报播放器域名错误日志
      reportErrorDomain(domain);
    }
  }
  // 兼容运维漏配 /player-health.json 或文件返回 404 的情况。
  console.warn('[播放器域名] 所有域名 health 检测失败，开始使用旧版 HEAD 检测');
  for (const domain of currentDomainList) {
    if (domain === currentDomain) continue;

    const isOk = await testDomainByResponseOk(domain);
    if (isOk) {
      console.log('[播放器域名] 旧版 HEAD 检测到可用域名:', domain);
      cacheDomain(domain);
      EventBus.emit("changePlayDomainNotication");
      return domain;
    }
  }

  console.error('[播放器域名] health 和旧版 HEAD 检测都失败，兜底使用第一个域名');
  const fallbackDomain = currentDomainList[0];
  if (fallbackDomain && fallbackDomain !== currentDomain) {
    cacheDomain(fallbackDomain);
    EventBus.emit("changePlayDomainNotication");
  }
  return fallbackDomain || null;
}

export function base64Encode(str: string): string {
  const encoder = new TextEncoder();
  const bytes = encoder.encode(str);
  const binary = Array.from(bytes).map(byte => String.fromCharCode(byte)).join('');
  return window.btoa(binary);
}

export function base64Decode(base64: string): string {
  const binary = window.atob(base64);
  const bytes = Uint8Array.from(binary, char => char.charCodeAt(0));
  const decoder = new TextDecoder();
  return decoder.decode(bytes);
}

export function reportErrorDomain(domain){
  //上报播放器域名错误日志
  const errorData = {
    userAgent: navigator.userAgent,
    locationUrl: window.location.href,
    errorUrl: domain,
  };
  uploadClienterrorlog(base64Encode(JSON.stringify(errorData)));
}
